import styled from "styled-components";

export const InfoField = styled.p`
  text-align: center;
  margin-top: 1.5rem;
  margin-bottom: 1.5rem;
`;
